import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Category', prop: 'category_id', references: 'admin/categories', referenceProp: 'name', customFilters: { type: 'product' } },
  { title: 'Discount', prop: 'discount_id', references: 'admin/discounts', referenceProp: 'code' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by category', prop: 'filters.category_id', type: 'autocomplete', references: 'admin/categories', referenceProp: 'name', enabled: true, customFilters: { type: 'product' } },
  { name: 'Filter by discounts', prop: 'filters.discount_id', type: 'autocomplete', references: 'admin/discounts', referenceProp: 'name', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const CategoryDiscounts = (props) => (
  <List
    title='Category Discounts'
    apiPath='admin/category_discounts'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default CategoryDiscounts
